<template>
  <figure class="highcharts-figure">
    <highcharts ref="chart" :options="options" />
    <p class="highcharts-description highcharts-linked-description">
      <strong>Figure : </strong>
      {{ $t('compGraphicsPurchasesInstrumentsPie.help') }}
    </p>
  </figure>
</template>

<script>
import Purchase from '@/models/carbon/Purchase.js'
import '@/plugins/highcharts.js'

export default {
  name: 'PurchasesInstrumentsPie',
  props: {
    ghgi: {
      type: Object,
      default: null
    },
    onlyGraphics: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    series: function () {
      let series = []
      const MAX_LENGTH = 9
      for (let purchase of this.ghgi.purchases) {
        if (purchase.category === 'lab.equipment') {
          let oindex = series.findIndex(
            (obj) =>
              obj.name ===
              purchase.code.toUpperCase() +
                ' - ' +
                Purchase.getDescription(purchase.code)
          )
          if (oindex < 0) {
            series.push({
              name:
                purchase.code.toUpperCase() +
                ' - ' +
                Purchase.getDescription(purchase.code),
              y: purchase.intensity.intensity,
              uncertainty: purchase.intensity.uncertainty
            })
          } else {
            series[oindex].y += purchase.intensity.intensity
            series[oindex].uncertainty += purchase.intensity.uncertainty
          }
        }
      }
      series = series.slice().sort((a, b) => {
        return b.y - a.y
      })
      let newseries = []
      if (series.length > MAX_LENGTH) {
        newseries.push({
          name: this.$t('compGraphicsPurchasesInstrumentsPie.others'),
          y: 0,
          uncertainty: 0
        })
        let i = 0
        for (let code of series) {
          if (i < MAX_LENGTH) {
            newseries.push(code)
          } else {
            newseries[0].y += code.y
            newseries[0].uncertainty += code.uncertainty
          }
          i += 1
        }
      } else {
        newseries = series
      }
      return newseries
    },
    options: function () {
      let self = this
      let total = 0
      if ('lab.equipment' in this.ghgi.emissions.purchases.categories) {
        total =
          this.ghgi.emissions.purchases.categories['lab.equipment'].intensity
      }
      return {
        chart: {
          type: 'pie'
        },
        title: {
          verticalAlign: 'middle',
          floating: true,
          text: `<b>${self.$options.filters.splitNumberTons(
            Math.round(total)
          )} ${self.$t('t.co2e')} </b>`
        },
        plotOptions: {
          pie: {
            innerSize: '60%',
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              formatter () {
                return `<b>${
                  this.point.name
                }:</b> ${self.$options.filters.splitNumberTons(
                  this.y
                )} ${self.$t('t.co2e')}`
              }
            },
            showInLegend: true
          }
        },
        series: [
          {
            name: this.$t('carbon.footprint'),
            colorByPoint: true,
            data: this.series
          }
        ],
        legend: {
          enabled: false
        },
        tooltip: {
          formatter: function () {
            return `${this.key}<br/><b>${self.$options.filters.splitNumberTons(
              this.y
            )} ${self.$t('t.co2e')}</b>`
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.highcharts-figure {
  min-width: 320px;
  max-width: 700px;
  margin: 1em auto;
}
.highcharts-description {
  text-align: center;
  color: '#777777';
  font-style: italic;
}
</style>
